// extracted by mini-css-extract-plugin
module.exports = {"CancelButton":"ConfirmModal_CancelButton__AyXte","AcceptButton":"ConfirmModal_AcceptButton__sb3_6"};